import './SubPages.css';
import React from "react";
import ConcreteButton from "./components/ConcreteButton.js";


function About() {

    return (
        <div class="about">
            <div className="aboutLeft">
                <h1 className="subpageHeader aboutHeader"> innovating since 2020</h1>
                <p className="aboutText"> Cerise [ce·​rise] a rich, vivid shade of reddish pink. </p>
                <p className="aboutText"> Our first project was to build an app for Dated, an online dating startup that aimed to solve major problems in the online dating industry. We built their initial minimum viable product (mvp), which launched on ios and android in May of 2020, and grew to over 30,000 users by July, helping them to secure a seed round investment and an eventual buyout. </p>
                <p className="aboutText"> Since then, we’ve been helping other early stage startups, nonprofits, and small businesses build minimum viable products, expand on their existing technology, and scale to support larger user bases. We also develop some of our own applications and technology resources for other developers to use. We choose the startups we partner with carefully, ensuring that their values and end goal match ours.</p>
                <p className="aboutText">   </p>
                {/* <p className="aboutText"> As a female lead technology firm, the femininity of cerise represents our commitment to improving the gender diversity in the technology industry. In particular, we love to work with female founded early stage tech startups. </p> */}
                <div className="workwithusButton">
                    <ConcreteButton isSmall={true} text="work with us" href="/mission" />
                </div>
            </div>
            <div className="aboutRight">
                <div className="openSourceRectangle">
                    <h2 className="openSourceHeader"> our youth education program</h2>
                    <p className="aboutText"> To help address and improve the diversity gap in tech and entrepreneurship, we are proud to sponsor <u> Future Tech Founders</u>, an education program for high school students aspiring to one day build a technology product.  </p>
                    <p className="aboutText"> Cerise provides financial aid for students from low income families, in hopes that the program will be accessible to all. </p>
                    <div className="browsegitButton">
                        <ConcreteButton isSmall={true} text="learn more" href="https://future-tech-founders.org/" />
                    </div>
                </div>
            </div>

        </div>
    )
}

export default About;